import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReauth } from '../../../../redux-store/services/services.utils'

export const metadataApi = createApi({
  reducerPath: 'metadataApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getValidationRules: builder.query({
      query: (guidelineId, isStrict = 0) =>
        `metadata/validationRules/${guidelineId}?strict=${isStrict}`,
    }),
  }),
})
